import styled from "styled-components"
import { GenericListContainer } from "../GenericList/GenericList.styled";



const ListItem = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    flex-grow: 2;
    height: 64px;
    border-radius: 8px;
    border: none;
    background-color: ${props => props.theme.colors.white};
    gap: 16px;
`;

const ListText = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const ListTitle = styled.p`
    font-size: ${props => props.theme.fonts.size.b2};
    font-weight: 400;
    margin: 0;
    line-height: normal;
    font-family: ${(props) => props.theme.fonts.family.inter}
`;

const ListSubtitle = styled.p`
    font-size: ${props => props.theme.fonts.size.lt1};
    font-weight: 300;
    margin: 0;
    line-height: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: wrap;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    box-orient: vertical;
    font-family: ${(props) => props.theme.fonts.family.inter}
`;

const ConfigurationIconWrapper = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 2px solid ${props => props.theme.colors.clearGray};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.theme.colors.white};
    cursor: pointer; 
`;

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.clearGray};
  width: 24px;
  height: 24px;

  margin-left: ${(props) => (props.$position === 'right' ? 'auto' : '0')};
  margin-right: ${(props) => (props.$position === 'left' ? '8px' : '0')};

  svg {
    font-size: 24px;
  }
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;


export {
    ListItem,
    ListTitle,
    ListSubtitle,
    ListText,
    ConfigurationIconWrapper,
    ArrowWrapper,
    FlexContainer
}